import React from "react";
import { Theme } from "@material-ui/core";
import { Grid, Typography, useMediaQuery } from "@mui/material";

const InfoGraphicsCard = ({
    title,
    content,
    image,
    theme,
    reverse,
  }: {
    title: string;
    content: string;
    image: string;
    theme: Theme;
    reverse?: boolean;
  }) => {
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
    return (
      <Grid
        container
        spacing={4}
        direction={reverse ? 'row-reverse' : 'row'}
        style={{ maxWidth: 900, minWidth: 300, width: '100%' }}
      >
        <Grid container item xs={isMobile ? 12 : 7} alignSelf={'flex-end'}>
          <Grid item xs={10}>
            <Typography variant="h5" style={{ fontWeight: 'bold', fontSize: 30 }}>
              {title}
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant="body1" style={{ fontSize: 20 }}>
              {content}
            </Typography>
          </Grid>
        </Grid>
        <Grid container item xs={isMobile ? 12 : 5}>
          <img
            src={image}
            style={{ width: '100%', height: '300px', objectFit: 'cover', borderRadius: 4 }}
          />
        </Grid>
      </Grid>
    );
  };

  export default InfoGraphicsCard;